export enum RouteKeys {
  List = '/pages/',
  New = '/pages/new',
  Edit = '/pages/:id/edit',
}
